import React, { useState } from "react";
import { Box, Tabs, Tab, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ClinicServices from "./ClinicServices";
import CreateServices from "./CreateServices";
import ServiceDetails from "./ServiceDetails";

const ClinicServicesTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [openTabs, setOpenTabs] = useState([
    { id: "services", label: "Services", component: <ClinicServices onServiceClick={handleServiceClick} /> },
    { id: "create-services", label: "Create Services", component: <CreateServices /> },
  ]);

  // **Handle Service Click - Open New Tab**
  function handleServiceClick(service) {
    const existingTab = openTabs.find((tab) => tab.id === service.service_no);
    if (!existingTab) {
      setOpenTabs((prev) => [
        ...prev,
        { id: service.service_no, label: service.service, component: <ServiceDetails service={service} /> },
      ]);
    }
    setActiveTab(openTabs.length); // Switch to new tab
  }

  // **Handle Tab Close**
  const handleCloseTab = (index) => {
    setOpenTabs((prev) => prev.filter((_, i) => i !== index));
    setActiveTab((prev) => (prev >= index ? prev - 1 : prev)); // Adjust active tab
  };

  return (
    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
      {/* Tabs Header */}
      <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} textColor="primary" indicatorColor="primary">
        {openTabs.map((tab, index) => (
          <Tab
            key={tab.id}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {tab.label}
                {index > 1 && ( // Prevent closing "Services" and "Create Services" tabs
                  <IconButton size="small" onClick={() => handleCloseTab(index)} sx={{ ml: 1 }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Tabs Content */}
      <Box sx={{ p: 3 }}>{openTabs[activeTab]?.component}</Box>
    </Box>
  );
};

export default ClinicServicesTabs;
